import React, { useEffect, useState } from 'react';
import { Box, TableContainer, Paper, Table, TableHead, TableBody, TableRow, TableCell, Button, Typography } from '@mui/material';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../util/axios_instance';

function Journals() {
    const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;
    let page = 0;
    const size = 10;
    const navigate = useNavigate();


    const [journalList, setJournalList] = useState([]);
    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`${BACKEND_HOST}/journal/get_journals?page=${page}&size=${size}`, {
                withCredentials: true
            });
            setJournalList(response.data)
        } catch (err) {
            console.log(err)
        }
    };

    const getJournals = (journal_id, journal_title) => {
        navigate('/journal_entries', { state: { journal_id, journal_title } });
    }

    function getCountdownDifference(fromDate) {
        var now = moment(new Date());
        var end = moment(fromDate);

        var diffDuration = moment.duration(end.diff(now));
        var years = diffDuration.years();
        var months = diffDuration.months();
        var days = diffDuration.days();
        return `${years} years, ${months} months, ${days} days`;
    }

    const createJournal = () => {
        navigate('/new_journal');
    }

    return (
        <Box display="flex"
            flexDirection={"column"}
            width="75vw" // Set width to 50% of the viewport width
            alignItems={'center'}
            justifyContent={'center'}
            margin={'auto'}
            marginTop={12}
            padding={3}
            borderRadius={5}

            sx={{
                ":hover": {
                    boxShadow: "10px 10px 20px #ccc",
                }
            }}>
            <Typography variant='h2' padding={3} textAlign={'center'}>My Journals</Typography>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 400 }} aria-label='Journal Table'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Journal</TableCell>
                            <TableCell>Delivery Date</TableCell>
                            <TableCell>Countdown</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {journalList.map((row) => (

                            <TableRow
                                key={row.journalTitle}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">{row.journalTitle}</TableCell>
                                <TableCell component="th" scope="row">{moment(row.timeCapsuleConfiguration.deliveryDate).format('MMMM Do, YYYY')}</TableCell>
                                <TableCell component="th" scope="row">{getCountdownDifference(row.timeCapsuleConfiguration.deliveryDate)}</TableCell>
                                <TableCell><Button sx={{ marginTop: 3, borderRadius: 3 }} variant='contained' onClick={() => getJournals(row.id, row.journalTitle)}>View Journal</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Button sx={{ marginTop: 3, borderRadius: 3 }} variant='contained' onClick={createJournal}>Create a Journal</Button>
        </Box>
    )
}

export default Journals;